import { customWishList } from './wish-list-en.i18n';

export const en = {
  customWishList: customWishList,
};
